var exports = {
  "i": "hideOnDesktop__tmbQEf",
};

module.exports = exports;
